import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import * as fromAdmin from '@app/client/account/admin/reducers';
import { EnvironmentActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers';
import { Identity } from '@app/shared/models/identity';
import { Team } from '@app/shared/models/team';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

  activeIdentity$: Observable<Identity>;
  teams$: Observable<Team[]>;
  teamSelected$: Observable<Team>;
  planType$: Observable<any>;
  route$: Observable<any>;
  isAdministrator$: Observable<boolean>;

  constructor(
    private store$: Store<fromRoot.State & fromAdmin.State>,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.activeIdentity$ = this.store$.select(fromRoot.getActiveIdentity);
      this.teams$ = this.store$.select(fromRoot.getUserTeams);
      this.teamSelected$ = this.store$.select(fromRoot.getActiveTeam);
      this.planType$ = this.store$.select(fromRoot.getPlanType);
      this.route$ = this.store$.select(fromRoot.getRoute);
      this.isAdministrator$ = this.store$.select(fromRoot.getIsAdministrator);

      this.store$.pipe(select(fromRoot.getIsAdministrator), take(1)).subscribe((isAdministrator) => {
        if (isAdministrator) {
          this.store$.dispatch(EnvironmentActions.ScanUpdates());
        }
      });
    }
  }
}
